'use client';

import 'reflect-metadata';
import React from 'react';
import { OnboardingProvider } from '$modules/onboarding/context';
import Layout from '$modules/onboarding/layout';
import { ToastContainer } from '@brahma/components';
const OnboardingLayout = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <OnboardingProvider data-sentry-element="OnboardingProvider" data-sentry-component="OnboardingLayout" data-sentry-source-file="layout.tsx">
      <Layout data-sentry-element="Layout" data-sentry-source-file="layout.tsx">{children}</Layout>
      <ToastContainer data-sentry-element="ToastContainer" data-sentry-source-file="layout.tsx" />
    </OnboardingProvider>;
};
export default OnboardingLayout;